import React, { useEffect, useCallback } from 'react';
import SearchNavigationItem from './SearchNavigationItem';
import { useDispatch } from 'react-redux';
import { setActiveTab as setActiveTabAction } from '../../Actions/Search.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const SearchNavigation = (props) => {
  const { activeTab = 'products' } = useTypedSelector<any>(
    (state) => state.search
  );
  const dispatch = useDispatch();

  const setActiveTab = useCallback(() => {
    var productListingHits = props.productListing?.totalProductsCount;
    var categoryListingHits = props.categoryListing?.total ?? 0;
    var pagesListingHits = props.pagesListing?.total ?? 0;
    var brandListingHits = props.brandListing?.total ?? 0;

    if (productListingHits > 0) {
      dispatch(setActiveTabAction('products'));
    } else if (categoryListingHits > 0) {
      dispatch(setActiveTabAction('categories'));
    } else if (pagesListingHits > 0) {
      dispatch(setActiveTabAction('pages'));
    } else if (brandListingHits > 0) {
      dispatch(setActiveTabAction('brands'));
    }
  }, [
    dispatch,
    props.brandListing?.total,
    props.categoryListing?.total,
    props.pagesListing?.total,
    props.productListing?.totalProductsCount,
  ]);

  useEffect(() => {
    setActiveTab();
  }, [setActiveTab]);

  return (
    <>
      {props.totalHits > 0 && (
        <ul className="mt-4 flex flex-row gap-4 overflow-y-auto scrollbar-none lg:mt-6 sm-down:-mr-4">
          {props.productListing.totalProductsCount > 0 && (
            <SearchNavigationItem
              resultKey={'products'}
              quantity={props.productListing.totalProductsCount}
              active={activeTab == 'products'}
            />
          )}
          {props.categoryListing.total > 0 && (
            <SearchNavigationItem
              resultKey={'categories'}
              quantity={props.categoryListing.total}
              active={activeTab == 'categories'}
            />
          )}
          {props.pagesListing.total > 0 && (
            <SearchNavigationItem
              resultKey={'pages'}
              quantity={props.pagesListing.total}
              active={activeTab == 'pages'}
            />
          )}
          {props.brandListing.total > 0 && (
            <SearchNavigationItem
              resultKey={'brands'}
              quantity={props.brandListing.total}
              active={activeTab == 'brands'}
            />
          )}
        </ul>
      )}
    </>
  );
};

export default SearchNavigation;
